/* ============================================================
   PREMIUM REELS — Instagram-style shoppable video carousel
   Videos are never downloaded until they scroll into view, and
   only the centred reel autoplays. Keeps LCP/CLS clean.
   ============================================================ */
(function () {
  'use strict';

  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SAVE_DATA = navigator.connection && navigator.connection.saveData;

  var ICON_MUTE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5L6 9H2v6h4l5 4V5z"/><path d="M23 9l-6 6M17 9l6 6"/></svg>';
  var ICON_UNMUTE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 5L6 9H2v6h4l5 4V5z"/><path d="M15.5 8.5a5 5 0 010 7"/><path d="M18.5 5.5a9 9 0 010 13"/></svg>';

  function initSection(section) {
    if (!section || section.dataset.pmReady) return;
    section.dataset.pmReady = '1';

    var track = $('.pm-reels__track', section);
    var reels = $$('.pm-reel', section);
    if (!track || !reels.length) return;

    var autoplay = section.dataset.autoplay === 'true' && !REDUCED && !SAVE_DATA;
    var muted = true;

    /* --- lazily attach the video source only when near the viewport --- */
    function hydrate(reel) {
      var video = $('video', reel);
      if (!video || video.dataset.pmHydrated) return video;
      video.dataset.pmHydrated = '1';
      var src = video.dataset.src;
      if (src) {
        // Support multiple sources declared as data-src on <source>
        var sources = $$('source[data-src]', video);
        if (sources.length) {
          sources.forEach(function (s) { s.src = s.dataset.src; });
        } else {
          video.src = src;
        }
        video.load();
      } else {
        $$('source[data-src]', video).forEach(function (s) { s.src = s.dataset.src; });
        if ($$('source[data-src]', video).length) video.load();
      }
      return video;
    }

    function play(reel) {
      var video = hydrate(reel);
      if (!video) return;
      video.muted = muted;
      var p = video.play();
      if (p && p.catch) p.catch(function () { /* autoplay blocked — leave the poster up */ });
      reel.classList.add('is-playing');
    }
    function pause(reel) {
      var video = $('video', reel);
      if (video && !video.paused) video.pause();
      reel.classList.remove('is-playing');
    }

    /* --- viewport driven playback --- */
    if ('IntersectionObserver' in window) {
      var nearIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) hydrate(e.target); });
      }, { rootMargin: '400px' });
      reels.forEach(function (r) { nearIo.observe(r); });

      if (autoplay) {
        var playIo = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.intersectionRatio > 0.65) play(e.target);
            else pause(e.target);
          });
        }, { threshold: [0, 0.65, 1] });
        reels.forEach(function (r) { playIo.observe(r); });
      }
    }

    /* --- explicit controls --- */
    reels.forEach(function (reel) {
      var playBtn = $('.pm-reel__play', reel);
      if (playBtn) {
        playBtn.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          reels.forEach(function (r) { if (r !== reel) pause(r); });
          play(reel);
        });
      }
      var muteBtn = $('.pm-reel__mute', reel);
      if (muteBtn) {
        muteBtn.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          muted = !muted;
          $$('video', section).forEach(function (v) { v.muted = muted; });
          $$('.pm-reel__mute', section).forEach(function (b) {
            b.innerHTML = muted ? ICON_MUTE : ICON_UNMUTE;
            b.setAttribute('aria-label', muted ? (section.dataset.labelUnmute || 'Unmute') : (section.dataset.labelMute || 'Mute'));
            b.setAttribute('aria-pressed', muted ? 'false' : 'true');
          });
        });
      }
      // Tap the reel body to toggle playback on touch devices
      reel.addEventListener('click', function (e) {
        if (e.target.closest('a, button')) return;
        var video = $('video', reel);
        if (!video) return;
        if (video.paused) { reels.forEach(function (r) { if (r !== reel) pause(r); }); play(reel); }
        else pause(reel);
      });
    });

    /* --- arrows --- */
    function scrollByCard(dir) {
      var card = reels[0];
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '16');
      track.scrollBy({ left: dir * (card.offsetWidth + gap), behavior: REDUCED ? 'auto' : 'smooth' });
    }
    $$('[data-pm-reels-prev]', section).forEach(function (b) { b.addEventListener('click', function () { scrollByCard(-1); }); });
    $$('[data-pm-reels-next]', section).forEach(function (b) { b.addEventListener('click', function () { scrollByCard(1); }); });

    function syncArrows() {
      var prev = $('[data-pm-reels-prev]', section);
      var next = $('[data-pm-reels-next]', section);
      if (prev) prev.disabled = track.scrollLeft < 8;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
    }
    track.addEventListener('scroll', syncArrows, { passive: true });
    syncArrows();

    // Stop everything when the tab is hidden — saves battery and data
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) reels.forEach(pause);
    });
  }

  function boot() { $$('[data-pm-reels]').forEach(initSection); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
